declare var jQuery:any;
declare var product_page_localize:any;

export class Ajax {
    admin_url: string;
    nonce: string;
    data: any;

    constructor() {
        this.admin_url = product_page_localize.ajax_url;
        this.nonce = product_page_localize.nonce;
        this.data = {
            nonce: this.nonce
        };
    }
    public setData(key:string, value:any):void {
        this.data[key] = value;
    }

    public getData(key:string):any {
        if (key in this.data) {
            return this.data[key];
        }
        return null;
    }

    public restartData() {
        this.data = {
            nonce: this.nonce
        };
    }

    public jAjax(url:string, type:string, dataType:string, data:any, onSuccess:any, onError:any) {
        let ajaxArgs:any = {
            type : type,
            dataType : dataType,
            url : url,
            success: onSuccess,
            error: onError,
        }
        if (data) {
            ajaxArgs['data'] = data;
        }
        jQuery.ajax(ajaxArgs);
    }

    public callWPAjax(action:string, onSuccess:any=null, onError:any=null, method:string='post') {
        this.data['action'] = action;
        if (!onSuccess) {
            onSuccess = (resp:any) => {console.log(resp)}
        }
        if (!onError) {
            onError = (err:any) => {console.error(err)}
        }
        this.jAjax(
            this.admin_url,
            method,
            "json",
            this.data,
            onSuccess,
            onError
        )
    }
}
